<template>
  <div class="hearder">
    <img class="goback" @click="goback" src="../../static/images/fanhui.png" alt="" />
    <img class="gohome" v-if="homeshow === '1'" @click="goHome" src="../../static/images/home.png" alt="" />
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    homeshow: {
      type: String,
      default: '1'
    }
  },
  created() {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
    goHome() {
      //判断商家审核状态 进行跳转；
      let url = '/front/Appsto/pstatus';
      this.$request.post(url, {}, res => {
        console.log(res)
        //status -2 未完善信息  0 审核中 1审核通过 -1 审核失败
        if (res.result.status == 1) {
          this.$router.push('/projectList');
        }else {
          this.$router.push('/shopinformation');
        }
        if (res.result.status == -99) {
          this.$router.push('/');
        }
        
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.hearder {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  background: #299e72;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;

  .goback {
    position: absolute;
    top: 50%;
    left: 0.3rem;
    transform: translate(-50%, -50%);
    width: 0.3rem;
  }
  .gohome {
    position: absolute;
    top: 50%;
    right: 0rem;
    transform: translate(-50%, -50%);
    width: 0.4rem;
  }

  .title {
    color: white;
    font-size: 0.32rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerBar.vue